<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">400号码秒杀</a></li>
            </ul>
        </div>
        <div class="formbody">    
            <div class="jian">&nbsp;</div>
            <div class="welinfo">
                <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
                <b>温馨提示：</b>
            </div>    
            <ul class="infolist">
                <li><span><b class="ea2020" style="font-size: 20px;">秒杀成功后，请联系客服提供信息用于开通400号码</b></span></li>
            </ul> 
    
            <div id="usual1" class="usual">     
                <div class="itab">
                    <ul> 
                        <li><a href="" class="selected">支付宝充值</a></li>
                    </ul>
                </div>     
  	            <div id="tab1" class="tabson">    
                    <ul class="forminfo">
                        <li><label>订单号<b>*</b></label><input name="" v-model="bidKey" type="text" disabled="true" class="dfinput" value=""  style="width:518px;"/></li>
                        <li><label>秒杀用户门牌号<b>*</b></label><input name="" type="text" class="dfinput" disabled="true" value="" v-model="account"  style="width:518px;"/></li>                
                        <li><label>秒杀的400号码<b>*</b></label><input name="" type="text" class="dfinput" disabled="true" value="" v-model="phone"  style="width:518px;"/></li>                
                        <!-- <li><label>备注说明</label><input name="" type="text" class="dfinput" value=""  style="width:518px;"/></li> -->
                        <li><label>&nbsp;</label><input class="sure1" type="button" value="提交支付宝或网上银行支付" @click="paySubmit()">&nbsp;</li>
                    </ul>    
                </div>     
  	            <div id="tab2" class="tabson">    
                    <p class="lh33">
                    充值及发票<br/>
                    1）支持网银及支付宝在线充值<br/>
                    最低100元起充。可开票用户充值满1000元起寄送发票；1000元以下请自付快递费<br/>
                    2）线下汇款（到账需客服确认1－2个工作日）<br/>
                    账号明细：<br/>
                    *支付宝 对公帐号：pay2@2office.cn （注意输入后会显示：杭州电码科技有限公司，以免误打）<br/>
                    ****对公户名: 杭州电码科技有限公司 帐号: 74818100386771 开户行: 杭州银行西城支行 <br/>
                    以上请注明充值用途（对应门牌号或400号码）<br/>
                    </p>    
                </div>
            </div>
    
            <div class="tip tip1 ">
                <div class="tiptop"><span>云验证-支付宝支付信息确认</span><a></a></div>   
                <ul class="forminfo">    
                    <li><label class="tdlast" >订单号：</label><span class="lh33">{{bidKey}}</span> </li>                    
                    <li><label class="tdlast" >门牌号：</label><span class="lh33">{{account}}</span></li>
                    <li><label class="tdlast" >本次充值金额：</label><span class="lh33">{{allMoney}}</span></li>
                    <li><label>&nbsp;</label>
                        <a :href="payUrl"><img src="../../assets/images/alipay_bwrx.gif" ></a>
                    </li>
                </ul>        
            </div>

        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            account:'',
            money:300,
            bidKey:'',
            allMoney:300,
            payUrl:'',
            phone: '',
            id: 0,
        }
    },
    mounted(){
        this.id = this.$route.query.id;
        this.phone = this.$route.query.phone;
        this.getData();
    },
    methods:{
      getData(){
        var that = this
        let param = {}
        this.$ajax({
            method: 'post',
            url: this.GLOBAL.serverSrc + "/person/pay400.json",
            data: param,
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'token' : this.GLOBAL.token
            }
        }).then(function(res) {
            if(res.data.code == '0000000')
            {
                //console.log(res)
                that.account = res.data.account;
                that.bidKey = res.data.bidKey;
            }
            else
            {
                alert(res.data.msg)
                return false;
            }
        })
      },
      paySubmit(){
        let that = this;
        let data = {'bidKey':this.bidKey,'money':this.money, 'phone': this.phone, 'id': this.id}
        this.$ajax({
              method: 'post',
              url: this.GLOBAL.serverSrc + "/person/alipaysubmit400.json",
              data: data,
              headers: {
                  'Content-Type': 'application/json; charset=UTF-8',
                  'token' : this.GLOBAL.token
              }
          }).then(function(res) {
              if(res.data.code == '0000000')
              {
                  that.allMoney = res.data.allMoney;
                  that.payUrl = res.data.payUrl;
                  that.showSubmit();
              }
              else
              {
                  alert(res.data.msg)
                  return false;
              }
          })
      },
      showSubmit(){
            $(".tip1").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip1").fadeOut(200);
            })
      },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/person/chargeseconds400activity.vue